import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../services/auth.services'

@Component({
    selector: 'app-layout-promotion',
    templateUrl: './layout-promotion.component.html',
    // styleUrls: ['./layout-promotion.component.css']
})
export class LayoutPromotionComponent implements OnInit {
    en = {}
    showEN = true

    constructor(private auth: AuthService) {
    }

    ngOnInit() {
    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }

}



// WEBPACK FOOTER //
// ./src/app/promotion/layout-promotion/layout-promotion.component.ts